<template>
    <el-form :inline="true" class="m_b_12 positionSearch" ref="form">
        <el-form-item label="状态:">
            <el-select size="medium" v-model="positionSearch.status" @change="getFormList">
                <el-option v-for="item in stateData" :label="item.value" :value="item.key" :key="item.key"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="类型:">
            <el-select size="medium"  v-model="positionSearch.jobType" @change="getFormList">
                <el-option v-for="item in typeData" :label="item.value" :value="item.key" :key="item.key"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-input class="w230" size="medium" suffix-icon="el-icon-search" placeholder="请输入职位名称或ID搜索" v-model="positionSearch.jobName" @keyup.enter.native="getFormList"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button size="small" type="primary" @click="getFormList">搜索</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
export default {
    props: [],
    data() {
        return {
            positionSearch: {
                status: '',
                jobType: ''
            },
            stateData: [
                {
                    key: '',
                    value: '全部'
                }, {
                    key: 1,
                    value: '上架中'
                }, {
                    key: 2,
                    value: '已下架'
                }
            ],
            typeData: [
                {
                    key: '',
                    value: '全部'
                }, {
                    key: 0,
                    value: '全职'
                }, {
                    key: 1,
                    value: '兼职'
                }
            ]
        }
    },
    methods: {
        getFormList() {
            this.$emit('searchPosition', 1)
        }
    }
}
</script>
<style lang="scss" scoped>
.w230{
    width: 230px
}
</style>

